import React from 'react'
import CardMenu from './CardMenu'


function Menu() {
  return (
    <div>
        <div className="partb2">
          <CardMenu
            link="/IMAGES/Screenshot 2024-03-08 230039.png"
            title="MONDAY"
            Headl="Our meals offer a nutritious blend of whole grains, vegetables, pulses, and spices, providing essential nutrients such as proteins, carbohydrates, and fiber, all while ensuring delightful flavors."
          />
          <CardMenu
            link="https://media.istockphoto.com/id/1256253385/photo/indian-lunch-box-or-tiffin-spicy-ladies-finger-dal-fry-rice-and-chapati.jpg?s=2048x2048&w=is&k=20&c=UKyvVQwz7ZIv6uHwtyat3ZUYdG5IGEH2R_nWKz6adM0="
            title="Tuesday"
            Headl="Indulge in our flavorful meals crafted with a balanced mix of wholesome ingredients, including whole grains, fresh vegetables, and aromatic spices, ensuring a nourishing."
          />
          <CardMenu
            link="https://media.istockphoto.com/id/666181300/photo/indian-vegetarian-office-or-school-lunch-box-or-tiffin-with-north-indian-or-maharashtrian.jpg?s=612x612&w=0&k=20&c=ae6PeLTMaSroB7wKnkznV1Cg7HQv-uJSYAonkozFad8="
            title="Wednesday"
            Headl="Experience the perfect harmony of taste and nutrition with our meals, carefully prepared with a rich combination of whole grains, crisp veggies, and savory spices, delivering essential."
          />
          <CardMenu
            link="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQT6Ojl6SU8TxCmGXo6ZsK10r9ciTjFJiCearH2k03KTg&s"
            title="Thursday"
            Headl="Savor the goodness of our meals, thoughtfully curated with a medley of whole grains, vibrant vegetables, hearty pulses, and aromatic spices, providing a nutritious feast for your senses."
          />
          <CardMenu
            link="https://t3.ftcdn.net/jpg/02/24/61/46/240_F_224614687_ySffxnZkyY5DWKfeYXsQ8LR35j6grFAf.jpg"
            title="Friday"
            Headl="Enjoy the goodness of nature in every meal, as our dishes are meticulously crafted with the finest whole grains, farm-fresh vegetables, wholesome pulses, and flavorful spices, offering a nutritious culinary journey."
          />
          <CardMenu
            link="https://t4.ftcdn.net/jpg/04/16/35/37/240_F_416353748_WjF5IlnLOTDz36UrfrHv0HhW0XB0ML7j.jpg"
            title="Saturday"
            Headl="Delight in the natural goodness of each meal, with our dishes expertly crafted using top-quality whole grains, fresh-from-the-farm vegetables, nutritious pulses, and fragrant spices, ensuring a wholesome dining experience."
          />
          <CardMenu
            link="https://t3.ftcdn.net/jpg/04/16/35/54/240_F_416355468_tQzYwygUjZWqTstFhiMatQBmPQrrMf55.jpg"
            title="Sunday"
            Headl="Savor the richness of nature in every dish, as our meals are carefully prepared with premium whole grains, farm-fresh vegetables, wholesome pulses, and aromatic spices, providing a nourishing culinary adventure."
          />
          <CardMenu
            link="https://media.istockphoto.com/id/1256252135/photo/indian-lunch-box-or-tiffin-spicy-ladies-finger-dal-fry-rice-and-chapati.jpg?s=612x612&w=0&k=20&c=41l_I4gPp0VSM4NFY_psrvEEtLzXLJDs8HDCQmru6K0="
            title="Holiday"
            Headl="Meals are a healthy combination of whole grains, veggies, pulses and spices and provide essential nutrients like proteins, carbohydrates, fibre etc without compromising on taste."
          />
        </div>
    </div>
  )
}

export default Menu